<template>
    <!-- 模板部分保持不变 -->
    <el-container class="Wrapper">
        <el-container class="container">
            <el-main class="main">
                <div class="main_item">
                    <div class="QRcode">
                        <div class="QRcodehead" >
							<el-form id="queryForm" :model="queryForm" label-width="100px">
							<el-row :gutter="18">
								<el-col :span="12">
								<el-form-item label="科室">
									<el-select v-model="queryForm.departmentId" show-message="false" placeholder="请选择科室" @change="handleSelectDepartmentChange">
										<el-option v-for="item in selectCurrDepartments" :key="item.departmentsId"
											:label="item.departmentName" :value="item.departmentsId" />
									</el-select>
								</el-form-item>
								</el-col>
								<el-col :span="12">
								<el-form-item label="详细地址">
									<el-input v-model="queryForm.address" placeholder="请输入详细地址" @keyup.enter="sifts"
										class="QRcodeSearch"></el-input>
								</el-form-item>
								</el-col>
							</el-row>
							</el-form>
                            <el-button type="primary" @click="sifts" class="QRcodeSearchBtn">查询</el-button>
                            <el-button type="primary" @click="showAddModal" class="QRcodeSearchBtn">新增</el-button>
                            <el-button type="danger" @click="batchDelete" class="QRcodeSearchBtn"
                                :disabled="selectedRows.length === 0 || isDeleting">
                                批量删除
                            </el-button>
                            <el-button type="success" @click="printSelected" class="QRcodeSearchBtn"
                                :disabled="selectedRows.length === 0">
                                打印选中
                            </el-button>
                        </div>

                        <div class="QRcodebody" style="margin-top: 2vh;">
                            <el-table :data="ManageUsers" height="70vh" style="width: 100%" v-loading="loading || isDeleting"
                                element-loading-text="处理中，请稍后..." @selection-change="handleSelectionChange"
                                ref="table">
                                <el-table-column type="selection" width="50"></el-table-column>
                                <el-table-column prop="courtyard" label="院区" width="120" />
                                <el-table-column prop="department" label="科室" width="120" />
                                <el-table-column prop="floor" label="楼层" width="120" />
                                <el-table-column prop="address" label="详细地址" width="100" />
                                <el-table-column label="二维码" width="100">
                                    <template #default="scope">
                                        <div
                                            style="width: 60px;height: 60px;display: flex;align-items: center;justify-content: center;">
                                            <el-image v-if="scope.row.qrcodeImage" fit="contain"
                                                :src="`https://199shq.com/api/common/download?name=${scope.row.qrcodeImage}`"
                                                @click="handleImageClick(`https://199shq.com/api/common/download?name=${scope.row.qrcodeImage}`)"
                                                style="cursor: zoom-in;" />
                                            <span v-else>暂无二维码</span>
                                        </div>
                                    </template>
                                </el-table-column>

                                <el-table-column label="操作" width="180">
                                    <template #default="scope">
                                        <el-button type="primary" 
                                            @click="edit(scope.row.id)">编辑</el-button>
                                        <el-button type="danger" 
                                            @click="deleteItem(scope.row.id)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>

                        <div class="QRcodefoot">
                            <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize"
                                @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                :page-sizes="[10, 20, 30, 40]" :total="total"
                                layout="total, sizes, prev, pager, next, jumper" />
                        </div>
                    </div>
                </div>
            </el-main>
        </el-container>
        <!-- 模态框等其他模板内容保持不变 -->
        <div class="QRcodetan">
            <!-- 新增用户模态框 -->
            <el-dialog v-model="addVisible" title="新增地址" width="500px" @close="resetAddForm">
                <el-form :model="addForm" label-width="100px">
                    <el-form-item label="院区">
                        <el-select v-model="addForm.courtyardId" placeholder="请选择院区" @change="handleCourtyardChange">
                            <el-option v-for="item in courtyardTree" :key="item.id" :label="item.name"
                                :value="item.id" />
                        </el-select>
                    </el-form-item>

                    <el-form-item label="科室" :disabled="!addForm.courtyardId">
                        <el-select v-model="addForm.departmentId" placeholder="请选择科室" @change="handleDepartmentChange">
                            <el-option v-for="item in currentDepartments" :key="item.departmentsId"
                                :label="item.departmentName" :value="item.departmentsId" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="楼层" :disabled="!addForm.departmentId">
                        <el-select v-model="addForm.floorId" placeholder="请选择楼层" @change="handleFloorChange">
                            <el-option v-for="item in currentFloors" :key="item.id" :label="item.number"
                                :value="item.id" />
                        </el-select>
                    </el-form-item>

                    <el-form-item label="详细地址">
                        <el-input v-model="addForm.address" placeholder="请输入详细地址" type="textarea" :rows="3" />
                    </el-form-item>
                </el-form>

                <template #footer>
                    <el-button @click="addVisible = false">取消</el-button>
                    <el-button type="primary" @click="submitAddForm">确定</el-button>
                </template>
            </el-dialog>

            <!-- 编辑用户模态框 -->
            <el-dialog v-model="editVisible" title="编辑地址" width="500px" @close="resetEditForm">
                <el-form :model="editForm" label-width="100px">
                    <el-form-item label="院区">
                        <el-select v-model="editForm.courtyardId" placeholder="请选择院区"
                            @change="handleEditCourtyardChange">
                            <el-option v-for="item in courtyardTree" :key="item.id" :label="item.name"
                                :value="item.id" />
                        </el-select>
                    </el-form-item>

                    <el-form-item label="科室" :disabled="!editForm.courtyardId">
                        <el-select v-model="editForm.departmentId" placeholder="请选择科室"
                            @change="handleEditDepartmentChange">
                            <el-option v-for="item in editCurrentDepartments" :key="item.departmentsId"
                                :label="item.departmentName" :value="item.departmentsId" />
                        </el-select>
                    </el-form-item>

                    <el-form-item label="楼层" :disabled="!editForm.departmentId">
                        <el-select v-model="editForm.floorId" placeholder="请选择楼层" @change="handleEditFloorChange">
                            <el-option v-for="item in editCurrentFloors" :key="item.id" :label="item.number"
                                :value="item.id" />
                        </el-select>
                    </el-form-item>

                    <el-form-item label="详细地址">
                        <el-input v-model="editForm.address" placeholder="请输入详细地址" type="textarea" :rows="3" />
                    </el-form-item>
                </el-form>

                <template #footer>
                    <el-button @click="editVisible = false">取消</el-button>
                    <el-button type="primary" @click="submitEditForm">确定</el-button>
                </template>
            </el-dialog>

            <!-- 图片预览组件 -->
            <el-image-viewer v-if="previewVisible" :url-list="[previewImage]" @close="previewVisible = false" />
        </div>
    </el-container>
</template>

<script setup>
import { ref, onMounted, computed, getCurrentInstance } from 'vue';
import instance from '../network/storester.js';
import { ElMessage, ElMessageBox, ElLoading } from 'element-plus';
import { useRouter } from 'vue-router';
import logoImg from '../image/image.jpeg';
import logosImg from '../image/logos.png';

// 获取组件实例
const { proxy } = getCurrentInstance();

// 状态管理
const ManageUsers = ref([]);
const loading = ref(true);
const feedinput = ref('');
const router = useRouter();
const isDeleting = ref(false); // 新增：用于标识批量删除过程

// 分页
const currentPage = ref(1);
const pageSize = ref(10);
const total = ref(0);

// 查询数据
const queryForm = ref({
    courtyardId: 8,
    courtyardName: '',
    departmentId: null,
    departmentName: '',
    floorId: null,
    floorName: '',
    address: '',
	pageNum: 0,
	pageSize: 20
});

// 新增数据
const addVisible = ref(false);
const addForm = ref({
    courtyardId: null,
    courtyardName: '',
    departmentId: null,
    departmentName: '',
    floorId: null,
    floorName: '',
    address: ''
});

// 编辑数据
const editVisible = ref(false);
const editForm = ref({
    id: null,
    courtyardId: null,
    courtyardName: '',
    departmentId: null,
    departmentName: '',
    floorId: null,
    floorName: '',
    address: ''
});

// 树状数据
const courtyardTree = ref([]);

// 图片预览相关
const previewVisible = ref(false);
const previewImage = ref('');

// 选中的行数据
const selectedRows = ref([]);
const isAllSelected = ref(false);

// 计算属性保持不变
const selectCurrDepartments = computed(() => {
    if (!queryForm.value.courtyardId || !courtyardTree.value.length) {
        return [];
    }
    const courtyard = courtyardTree.value.find(item => item.id === queryForm.value.courtyardId);
    return courtyard?.departmentList || [];
});

const currentDepartments = computed(() => {
    if (!addForm.value.courtyardId || !courtyardTree.value.length) {
        return [];
    }
    const courtyard = courtyardTree.value.find(item => item.id === addForm.value.courtyardId);
    return courtyard?.departmentList || [];
});

const currentFloors = computed(() => {
    if (!addForm.value.departmentId || !currentDepartments.value.length) {
        return [];
    }
    const department = currentDepartments.value.find(item => item.departmentsId === addForm.value.departmentId);
    return department?.floorList || [];
});

const editCurrentDepartments = computed(() => {
    if (!editForm.value.courtyardId || !courtyardTree.value.length) {
        return [];
    }
    const courtyard = courtyardTree.value.find(item => item.id === editForm.value.courtyardId);
    return courtyard?.departmentList || [];
});

const editCurrentFloors = computed(() => {
    if (!editForm.value.departmentId || !editCurrentDepartments.value.length) {
        return [];
    }
    const department = editCurrentDepartments.value.find(item => item.departmentsId === editForm.value.departmentId);
    return department?.floorList || [];
});

// 生命周期钩子
onMounted(() => {
    loadCourtyardTree();
    sifts();
});

// 加载树状数据
const loadCourtyardTree = () => {
    instance.get('/api/dispatching/getHospitalData')
        .then(res => {
            courtyardTree.value = res.data || [];
        })
        .catch(err => {
            ElMessage.error('加载院区结构失败');
        });
};

// 搜索与分页
const sifts = () => {
    loading.value = true;
	var param = `&address=${queryForm.value.address}`;
	if(queryForm.value.departmentId != null)param += `&departmentId=${queryForm.value.departmentId}`;
    instance.get(`/api/wxQrCode/list?pageNum=${currentPage.value}&pageSize=${pageSize.value}`+param)
        .then(res => {
            ManageUsers.value = res.data.data.dataList;
            total.value = res.data.data.total;
            selectedRows.value = [];
            isAllSelected.value = false;
            loading.value = false;
        })
        .catch(err => {
            ElMessage.error('加载数据失败,请重新登录');
            router.push('/login');
        });
};

// 处理选中行变化
const handleSelectionChange = (rows) => {
    selectedRows.value = rows;
    isAllSelected.value = rows.length > 0 && rows.length === ManageUsers.value.length;
};

// 全选/取消全选
const handleSelectAll = (val) => {
    const table = proxy.$refs.table;
    if (val) {
        ManageUsers.value.forEach(row => {
            table.toggleRowSelection(row, true);
        });
    } else {
        table.clearSelection();
    }
};

// 打印选中的二维码 (保持不变)
const printSelected = () => {
    // 打印逻辑保持不变
    if (selectedRows.value.length === 0) {
        ElMessage.warning('请先选择要打印的二维码');
        return;
    }

    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    const logoUrl = logoImg;
	const logosUrl= logosImg
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8">
        <style>
          @page { 
            margin: 0; 
            size: auto;
            background: #FFFBC7 !important;
          }

          html { 
            font-size: 16px; 
            --content-width: 80%;
          }

          body { 
            font-family: '微软雅黑', sans-serif; 
            background: #FFFBC7 !important; 
            color: black !important;
            margin: 0;
            padding: 0;
            width: 100vw;
            height: 100vh;
            position: relative;
          }

          .corner-logos {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            pointer-events: none;
            z-index: 1;
          }
          
          .corner-logo.top-left {
            position: absolute;
            top: 0.5rem;
            left: 0.5rem;
            width: 5rem;
            height: 5rem;
          }
          
          .corner-logo.top-right {
            position: absolute;
            top: 0.5rem;
            right: 0.5rem;
            width: 5rem;
            height: 5rem;
          }
          
          .corner-logo.bottom-left {
            position: absolute;
            bottom: 0.5rem;
            left: 0.5rem;
            width: 5rem;
            height: 5rem;
          }
          
          .corner-logo.bottom-right {
            position: absolute;
            bottom: 0.5rem;
            right: 0.5rem;
            width: 5rem;
            height: 5rem;
          }

          .print-container {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            padding: 0;
            position: relative;
            z-index: 2;
          }

          .print-header, .print-item {
            width: var(--content-width);
            max-width: calc(100% - 1.3rem);
          }

          .print-header {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 2rem;
          }

          .print-logo {
            width: 4.5rem;
            height: 4.5rem;
            margin-right: 1rem;
            background-color: #FFFBC7;
            padding: 0.3rem;
            border-radius: 0.5rem;
          }
            .print-logos{
               width: 4.5rem;
            height: 4.5rem;
            background-color: #FFFBC7;
            padding: 0.3rem;
            border-radius: 0.5rem;
            }
          .print-header h3 {
            font-size: 4.2rem;
            font-weight: bold;
            margin: 0;
          }

          .print-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            background: transparent;
            padding: 0;
          }

          .print-qrcode {
            margin-bottom: 2rem;
            width: 100%;
            background: white;
            border-radius: 0.5rem;
            box-shadow: 0 0 0 1px rgba(255,255,255,0.3), 0 0.5rem 1rem rgba(0,0,0,0.2);
          }

          .print-qrcode img {
            width: 100%;
            height: auto;
            border: none;
            padding: 0;
          }

          .print-address {
            text-align: center;
            width: 100%;
          }

          .print-address p {
            margin: 0.5rem 0;
            font-size: 1.7rem;
            line-height: 1.4;
          }
            .print-address .ke {
            margin: 0.5rem 0;
            font-size: 2rem;
            line-height: 1.4;
          }
               .print-address .kef {
            margin: 0.5rem 0;
            font-size: 2rem;
            line-height: 1.4;
          }
        </style>
      </head>
      <body>
        <div class="corner-logos">
          <img class="corner-logo top-left" src="${logosUrl}" alt="LOGO">
          <img class="corner-logo top-right" src="${logosUrl}" alt="LOGO">
          <img class="corner-logo bottom-left" src="${logosUrl}" alt="LOGO">
          <img class="corner-logo bottom-right" src="${logosUrl}" alt="LOGO">
        </div>
        
        ${selectedRows.value.map((item, index) => `
            
          <div class="print-container ${index < selectedRows.value.length - 1 ? 'page-break' : ''}">
            
            <div class="print-header">
              <img class="print-logo" src="${logoUrl}" alt="LOGO">
              <h3>医膳订餐码</h3>
            </div>
            <div class="print-item">
              <div class="print-qrcode">
                <img src="https://199shq.com/api/common/download?name=${item.qrcodeImage}" alt="二维码">
              </div>
              <div class="print-address">
                <p>${item.courtyard}</p>
                <p class="ke"> ${item.department} - ${item.floor}${item.address}</p>
                <p class="kef">客服电话：150 1319 9783</p>
                <p>监督电话：020-32208382</p>
              </div>
            </div>
          </div>
        `).join('')}
      </body>
    </html>
  `);
    iframeDoc.close();

    const adjustForPaperSize = () => {
        const contentWindow = iframe.contentWindow;
        const printEvent = new Event('print');
        contentWindow.dispatchEvent(printEvent);

        setTimeout(() => {
            const paperWidth = contentWindow.outerWidth;
            const paperHeight = contentWindow.outerHeight;

            let contentWidthRatio = '80%';
            if (paperWidth > 800) {
                contentWidthRatio = '60%';
            } else if (paperWidth < 400) {
                contentWidthRatio = '95%';
            }

            iframeDoc.documentElement.style.setProperty('--content-width', contentWidthRatio);

            contentWindow.requestAnimationFrame(() => {
                contentWindow.print();
                document.body.removeChild(iframe);
            });
        }, 500);
    };

    const allImages = iframeDoc.querySelectorAll('img');
    let loadedCount = 0;
    const totalImages = allImages.length;

    const checkImagesLoaded = () => {
        loadedCount++;
        if (loadedCount === totalImages) {
            adjustForPaperSize();
        }
    };

    allImages.forEach(img => {
        img.onload = checkImagesLoaded;
        img.onerror = checkImagesLoaded;
    });
};

// 批量删除选中项 - 循环调用单个删除接口
const batchDelete = () => {
    if (selectedRows.value.length === 0) {
        ElMessage.warning('请先选择要删除的记录');
        return;
    }

    // 确认删除对话框
    ElMessageBox.confirm(
        `确定要删除选中的 ${selectedRows.value.length} 条记录吗？`,
        '删除确认',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    ).then(async () => {
        isDeleting.value = true; // 开始删除，设置状态
        let successCount = 0;
        const totalCount = selectedRows.value.length;
        
        // 循环调用单个删除接口
        for (const row of selectedRows.value) {
            try {
                // 等待当前删除完成后再进行下一个
                await instance.get(`/api/wxQrCode/deleted/${row.id}`);
                successCount++;
            } catch (error) {
                ElMessage.error(`删除ID为 ${row.id} 的记录失败`);
                // 可以选择继续删除其他项或中断整个过程
                // 如果要中断，可使用 break;
            }
        }
        
        // 全部处理完毕后更新状态
        isDeleting.value = false;
        
        // 显示总体结果
        if (successCount > 0) {
            ElMessage.success(`成功删除 ${successCount}/${totalCount} 条记录`);
            // 重新加载数据
            sifts();
        } else {
            ElMessage.warning('所有选中记录删除失败');
        }
    }).catch(() => {
        // 取消删除
        ElMessage.info('已取消删除');
    });
};

// 新增相关方法 (保持不变)
const showAddModal = () => {
    addVisible.value = true;
};

const resetAddForm = () => {
    addForm.value = {
        courtyardId: null,
        courtyardName: '',
        departmentId: null,
        departmentName: '',
        floorId: null,
        floorName: '',
        address: ''
    };
};

const handleCourtyardChange = (val) => {
    const courtyard = courtyardTree.value.find(item => item.id === val);
    addForm.value.courtyardName = courtyard?.name || '';
    addForm.value.departmentId = null;
    addForm.value.departmentName = '';
    addForm.value.floorId = null;
    addForm.value.floorName = '';
};

const handleDepartmentChange = (val) => {
    const department = currentDepartments.value.find(item => item.departmentsId === val);
    addForm.value.departmentName = department?.departmentName || '';
    addForm.value.floorId = null;
    addForm.value.floorName = '';
};

const handleSelectDepartmentChange = (val) => {
    const department = selectCurrDepartments.value.find(item => item.departmentsId === val);
    queryForm.value.departmentName = department?.departmentName || '';
    queryForm.value.floorId = null;
    queryForm.value.floorName = '';
};

const handleFloorChange = (val) => {
    const floor = currentFloors.value.find(item => item.id === val);
    addForm.value.floorName = floor?.number || '';
};

// 编辑相关方法 (保持不变)
const edit = (id) => {
    instance.get(`/api/wxQrCode/${id}`)
        .then(res => {
            const data = res.data.data;
            editForm.value = {
                id: data.id,
                courtyardId: data.courtyardId,
                courtyardName: data.courtyardName,
                departmentId: data.departmentId,
                departmentName: data.departmentName,
                floorId: data.floorId,
                floorName: data.floorName,
                address: data.address
            };
            editVisible.value = true;
        })
        .catch(() => {
            ElMessage.error('获取编辑数据失败');
        });
};

const resetEditForm = () => {
    editForm.value = {
        id: null,
        courtyardId: null,
        courtyardName: '',
        departmentId: null,
        departmentName: '',
        floorId: null,
        floorName: '',
        address: ''
    };
};

const handleEditCourtyardChange = (val) => {
    const courtyard = courtyardTree.value.find(item => item.id === val);
    editForm.value.courtyardName = courtyard?.name || '';
    editForm.value.departmentId = null;
    editForm.value.departmentName = '';
    editForm.value.floorId = null;
    editForm.value.floorName = '';
};

const handleEditDepartmentChange = (val) => {
    const department = editCurrentDepartments.value.find(item => item.departmentsId === val);
    editForm.value.departmentName = department?.departmentName || '';
    editForm.value.floorId = null;
    editForm.value.floorName = '';
};

const handleEditFloorChange = (val) => {
    const floor = editCurrentFloors.value.find(item => item.id === val);
    editForm.value.floorName = floor?.number || '';
};

// 提交新增数据 (保持不变)
const submitAddForm = () => {
    if (!addForm.value.courtyardId) return ElMessage.error('请选择院区');
    if (!addForm.value.departmentId) return ElMessage.error('请选择科室');
    if (!addForm.value.floorId) return ElMessage.error('请选择楼层');
    if (!addForm.value.address) return ElMessage.error('请输入地址');
    instance.post('/api/wxQrCode/getQrCode', {
        courtyardId: addForm.value.courtyardId,
        courtyard: addForm.value.courtyardName,
        departmentId: addForm.value.departmentId,
        department: addForm.value.departmentName,
        floorId: addForm.value.floorId,
        floor: addForm.value.floorName,
        address: addForm.value.address
    })
        .then(() => {
            ElMessage.success('新增成功');
            addVisible.value = false;
            sifts();
        })
        .catch(() => {
            ElMessage.error('新增失败');
        });
};

// 提交编辑数据 (保持不变)
const submitEditForm = () => {
    if (!editForm.value.courtyardId) return ElMessage.error('请选择院区');
    if (!editForm.value.departmentId) return ElMessage.error('请选择科室');
    if (!editForm.value.floorId) return ElMessage.error('请选择楼层');
    if (!editForm.value.address) return ElMessage.error('请输入地址');

    instance.post(`/api/wxQrCode/getQrCode`, {
        id: editForm.value.id,
        courtyardId: editForm.value.courtyardId,
        courtyardName: editForm.value.courtyardName,
        departmentId: editForm.value.departmentId,
        departmentName: editForm.value.departmentName,
        floorId: editForm.value.floorId,
        floorName: editForm.value.floorName,
        address: editForm.value.address
    })
        .then(() => {
            ElMessage.success('更新成功');
            editVisible.value = false;
            sifts();
        })
        .catch(() => {
            ElMessage.error('更新失败');
        });
};

// 单个删除方法 (保持不变)
const deleteItem = (id) => {
    ElMessageBox.confirm('确认删除？')
        .then(() => {
            instance.get(`/api/wxQrCode/deleted/${id}`)
                .then(() => {
                    ElMessage.success('删除成功');
                    sifts();
                });
        })
        .catch(() => { });
};

// 分页方法 (保持不变)
const handleSizeChange = (val) => {
    pageSize.value = val;
    sifts();
};

const handleCurrentChange = (val) => {
    currentPage.value = val;
    sifts();
};

// 图片点击事件处理 (保持不变)
const handleImageClick = (url) => {
    previewImage.value = url;
    previewVisible.value = true;
};
</script>

<style scoped>
/* 样式保持不变 */
.QRcodehead {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.QRcodeSearch {
    width: 30vw !important;
}
#queryForm{
	.el-form-item {
	    margin-bottom: 0;
	    padding-bottom: 0;
	    border-bottom: none;
	}
}

.QRcodebody .el-table {
    margin-top: 15px;
    border-radius: 8px;
    overflow: hidden;
}

.QRcodefoot .el-pagination {
    margin-top: -20px;
    padding: 20px 0;
    justify-content: center;
}

.QRcodetan .el-dialog__body {
    padding: 20px;
}

.QRcodetan .el-form-item {
    margin-bottom: 15px;
}

.QRcodetan .el-textarea__inner {
    resize: none;
}

.QRcode {
    position: fixed;
    width: 85vw;
    top: 9vh;
    left: 11vw;
}

/* 打印区域样式 */
@media print {
    body * {
        visibility: hidden;
    }

    #print-area,
    #print-area * {
        visibility: visible;
    }

    #print-area {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
    }

    .print-item {
        display: inline-block;
        width: 150px;
        margin: 10px;
        text-align: center;
        page-break-inside: avoid;
    }

    .print-qrcode {
        margin-bottom: 10px;
    }

    .print-address {
        font-size: 12px;
        line-height: 1.5;
    }
}
</style>
    